export const architecture = [
  {
    icon: 'layers',
    title: 'Princípios & Design',
    blurb: 'Código que escala em time e no tempo: responsabilidades claras, baixo acoplamento e alta testabilidade.',
    items: ['SOLID', 'Clean Code', 'DDD', 'Design Patterns', 'TDD', 'Object Calisthenics'],
  },
  {
    icon: 'boxes',
    title: 'Arquiteturas',
    blurb: 'Domínio isolado da infraestrutura, com fronteiras explícitas e camadas que evoluem de forma independente.',
    items: [
      'Clean Architecture',
      'Hexagonal (Ports & Adapters)',
      'MVVM',
      'MVC',
      'CQRS',
      'Event-Driven',
      'Microsserviços',
      'Monólito modular',
    ],
  },
  {
    icon: 'network',
    title: 'Escala & Mensageria',
    blurb: 'Sistemas resilientes de alta vazão: processamento assíncrono, desacoplamento e observabilidade contínua.',
    items: [
      'Apache Kafka',
      'RabbitMQ',
      'Filas & Tópicos',
      'Pub/Sub',
      'Event Sourcing',
      'Redis / Cache',
      'Escalonamento horizontal',
      'Load Balancing',
      'Rate Limiting',
      'Observabilidade',
    ],
  },
];
